<mat-list class="simulations-list">
    <mat-list-item *ngFor="let simulation of simulationsList" [ngClass]="{selected: isSelected(simulation.code)}">
        <!-- <mat-icon *ngIf="simulation.isShared" mat-list-icon>folder_shared</mat-icon> -->
        <span mat-line>
            {{simulation.text?.shortLabel}}
            <app-tooltip *ngIf="simulation.text" [text]="simulation.text.summary"></app-tooltip>
            <span *ngIf="isAuthorShown && simulation.createdBy">({{simulation.createdBy}})</span>
        </span>
        <span mat-line *ngIf="isCreatedAtShown && simulation.createdAt">
            {{'dashboard.simulationsList.createdAt.shortLabel' | translate}} :
            {{simulation.createdAt | date:'dd/MM/yyyy'}}
        </span>
        <span mat-line *ngIf="simulation.updatedAt">
            {{'dashboard.simulationsList.updatedAt.shortLabel' | translate}} :
            {{simulation.updatedAt | date:'dd/MM/yyyy'}}
        </span>
        <span mat-line *ngIf="simulation.isShared" class="shared-line">
            <mat-icon aria-label="Share">share</mat-icon>
            <span>{{'dashboard.simulationsList.shared.shortLabel' | translate}}</span>
        </span>

        <form *ngIf="simulation.years?.length > 0 && simulation.visibility === visibilityType.template">
            <mat-form-field>
                <mat-label>{{'dashboard.simulationsList.to.shortLabel' | translate}}</mat-label>
                <mat-select [(ngModel)]="simulation.to" name="to">
                    <mat-option *ngFor="let option of simulation.years" [value]="option">
                        {{ option }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form>

        <button mat-icon-button (click)="onSelectSimu(simulation)"
            [disabled]="simulation.years?.length > 0 && !simulation.to && simulation.visibility === visibilityType.template"
            [matTooltip]="'dashboard.simulationsList.actions.select.shortLabel' | translate">
            <mat-icon aria-label="checkbox">{{ isSelected(simulation.code) ? 'check_box' : 'check_box_outline_blank'}}
            </mat-icon>
        </button>
        <button mat-icon-button *ngIf="simulation.years?.length > 0 && simulation.visibility === visibilityType.template" (click)="onSelectSimu(simulation, true)"
            [disabled]="simulation.years?.length > 0 && !simulation.to"
            [matTooltip]="'dashboard.simulationsList.actions.refresh.shortLabel' | translate">
            <mat-icon aria-label="Refresh">refresh</mat-icon>
        </button>
        <button mat-icon-button *ngIf="isActionAllowed" (click)="onDeleteSimu(simulation.code)" class="action-button"
            [matTooltip]="'dashboard.simulationsList.actions.delete.shortLabel' | translate">
            <mat-icon aria-label="Delete">delete</mat-icon>
        </button>
        <button mat-icon-button *ngIf="isActionAllowed" (click)="onShareSimu(simulation)" class="action-button"
            [matTooltip]="'dashboard.simulationsList.actions.share.shortLabel' | translate">
            <mat-icon aria-label="Share">share</mat-icon>
        </button>
    </mat-list-item>
</mat-list>
<mat-list *ngIf="simulationsList && !simulationsList.length">
    <mat-list-item>{{'dashboard.simulationsList.empty.summary' | translate}}</mat-list-item>
</mat-list>
